export default __webpack_public_path__ + "graph-volume.png?fe60313b2bb99019d4def6f9f2043ebe";